import { createSelector } from '@ngrx/store';
import { AppState } from '../states/app.state';

export const selectSessionState = (state: AppState) => state.session;

export const selectDraftBoards = createSelector(
  selectSessionState,
  (state) => state.draftBoards
);

export const selectDraftBoardsCount = createSelector(
  selectSessionState,
  (state) => state.draftBoards?.length || 0
);

export const selectSelectedBoard = createSelector(
  selectSessionState,
  (state) => {
    const savedSelectedBoard = localStorage.getItem('selectedBoard');
    return savedSelectedBoard ? JSON.parse(savedSelectedBoard) : state.selectedBoard;
  }
);

export const selectAllTags = createSelector(
  selectSessionState,
  (state) => state.tags
);
